import { getPrefix, getSessionToken } from "../bandung";
import { objectToFormData } from "./helpers";
import Axios from "axios";

const getAdminPrefix = () => `${getPrefix()}/app/admin`;

const getPrivacyEndPoint = () => `${getAdminPrefix()}/privacy`;
const getRecomputeEndPoint = () => `${getAdminPrefix()}/recompute`;
const getReindexEndPoint = () => `${getAdminPrefix()}/reindex`;
const getTermsEndPoint = () => `${getAdminPrefix()}/terms`;

const adminPrivacy = async () => {
  const form = objectToFormData({
    sessionToken: getSessionToken(),
  });
  try {
    const response = await Axios.post(getPrivacyEndPoint(), form);
    if (response.data.confirm) {
      return {
        code: "SUCCESS",
        message: "Privacy Policy successfully sent.",
      };
    } else {
      throw new Error(response.data.error);
    }
  } catch (error) {
    return {
      code: "ERROR",
      message: error.message || "An error occurred.",
    };
  }
};

const adminRecompute = async () => {
  const form = objectToFormData({
    sessionToken: getSessionToken(),
  });
  try {
    const response = await Axios.post(getRecomputeEndPoint(), form);
    if (!response.data.error) {
      return {
        code: "SUCCESS",
        message: "Recompute successful.",
      };
    } else {
      throw new Error(response.data.error);
    }
  } catch (error) {
    return {
      code: "ERROR",
      message: error.message || "An error occurred.",
    };
  }
};

const adminReindex = async () => {
  const form = objectToFormData({
    sessionToken: getSessionToken(),
  });
  try {
    const response = await Axios.post(getReindexEndPoint(), form);
    if (!response.data.error) {
      return {
        code: "SUCCESS",
        message: "Reindex successful.",
      };
    } else {
      throw new Error(response.data.error);
    }
  } catch (error) {
    return {
      code: "ERROR",
      message: error.message || "An error occurred.",
    };
  }
};

const adminTerms = async () => {
  const form = objectToFormData({
    sessionToken: getSessionToken(),
  });
  try {
    const response = await Axios.post(getTermsEndPoint(), form);
    if (response.data.confirm) {
      return {
        code: "SUCCESS",
        message: "Terms of Use successfully sent.",
      };
    } else {
      throw new Error(response.data.error);
    }
  } catch (error) {
    return {
      code: "ERROR",
      message: error.message || "An error occurred.",
    };
  }
};

export {
  adminPrivacy,
  adminRecompute,
  adminReindex,
  adminTerms,
};